//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            closedPeriod: moment()
        };
    },

    methods: {
        load: function load() {
            var _this = this;

            axios.get('/prototype/accounting/general-ledger/settings/gl-close/').then(function (response) {
                _this.closedPeriod = moment(response.data.month + '/1/' + response.data.year);
            });
        },
        save: function save() {
            var _this2 = this;

            var data = {
                closedPeriod: this.closedPeriod.format('MM/DD/YYYY')
            };

            axios.post('/prototype/accounting/general-ledger/settings/gl-close/update', data).then(function (response) {
                _this2.closedPeriod = moment(response.data.month + '/1/' + response.data.year);
                _this2.$snotify.success('The closed period was updated.');
            });
        }
    },
    created: function created() {
        Event.$on('refresh-gl-settings', this.load);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-gl-settings');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/settings/GlClose.vue
// module id = BsmN
// module chunks = 0 1